module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0058.jpg?v=278496b5";